import * as React from 'react';
import { useEffect, useRef } from 'react';
import FlairIcon from '../../../../atomic/atoms/FlairIcon';
import AiAvatar from '../AiChat/AiAvatar';
import { CommandItem } from './types';

type Props = {
  item: CommandItem;
  isSelected: boolean;
  optionId: string;
  onSelect: (item: CommandItem) => void;
};

const CommandBarItem: React.FC<React.PropsWithChildren<Props>> = ({
  item,
  isSelected,
  optionId,
  onSelect,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isSelected && ref.current) {
      ref.current.scrollIntoView({ block: 'nearest' });
    }
  }, [isSelected]);

  return (
    <div
      ref={ref}
      id={optionId}
      className={`command-bar-item ${isSelected ? 'selected' : ''}`}
      onClick={() => onSelect(item)}
      role="option"
      aria-selected={isSelected}
      data-testid={`command-bar-item-${item.id}`}>
      {item.type === 'ai' ? (
        <span className="command-bar-item-icon">
          <AiAvatar size="icon" />
        </span>
      ) : (
        item.icon && (
          <span className="command-bar-item-icon">
            <FlairIcon icon={item.icon} size="sm" />
          </span>
        )
      )}
      <span className="command-bar-item-label">{item.label}</span>
      {item.description && (
        <span className="command-bar-item-description">{item.description}</span>
      )}
    </div>
  );
};

export default CommandBarItem;
